import { FC, createElement, useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IAudience } from '../../apis/journeys';
import { useJourneyTree } from '../../hooks/use-journey-tree';
import { ROUTES } from '../../routes';
import { Journeys, JourneysProps } from './journeys';

export const JourneysContainer: FC = () => {
  const history = useHistory();
  const journeyTree = useJourneyTree();

  const [selectedAudience, setSelectedAudience] = useState<string>();

  const audiences = useMemo(() => {
    const bySlug = new Map<string, IAudience>();

    journeyTree.forEach((journey) =>
      journey.audiences?.forEach((audience) =>
        bySlug.set(audience.slug, audience)
      )
    );

    return Array.from(bySlug.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }, [journeyTree]);

  const journeys = useMemo(() => {
    if (!selectedAudience) return journeyTree;

    return journeyTree.filter((journey) =>
      journey.audiences?.some((audience) => audience.slug === selectedAudience)
    );
  }, [journeyTree, selectedAudience]);

  const onClickJourney = useCallback(
    (slug: string) => {
      history.push(`${ROUTES.JOURNEY_LIST_PAGE}/${slug}`);
    },
    [history]
  );

  const journeysProps: JourneysProps = {
    journeys,
    audiences,
    selectedAudience,
    onSelectAudience: setSelectedAudience,
    onClickJourney,
    breadcrumbs: [{ name: 'Jornada do Cidadão' }],
  };

  return createElement(Journeys, journeysProps);
};
